import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Row,
  Col,
  Button,
  Space,
  message,
  Layout,
  Modal,
  Input,
  ColorPicker,
} from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";

import {
  createTypeLine,
  getTypeLines,
  updateTypeLine,
} from "../api/typeLine/typeLineRequest";
import PermissionRender from "../components/PermissionRender";

const { Content } = Layout;

function TypeLines() {
  const [types, setTypes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false); // State to check if editing
  const [newType, setNewType] = useState("");
  const [newColor, setNewColor] = useState("");
  const [editingType, setEditingType] = useState(null); // State for the type being edited
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    setLoading(true);
    try {
      const data = await getTypeLines();
      setTypes(data); // Update state with the fetched data
    } catch (error) {
      message.error("Échec de la récupération des types de ligne.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddType = async () => {
    const hexString =
      typeof newColor === "string" ? newColor : newColor?.toHexString();
    if (newType.trim() && hexString.trim()) {
      try {
        await createTypeLine({
          name: newType,
          color: hexString.replace("#", ""),
        });

        setNewType("");
        setNewColor("");
        setIsModalVisible(false);
        fetchTypes();
        message.success("Type d'infraction ajouté");
      } catch (error) {
        message.error("Échec de l'ajout du type de ligne");
      }
    } else {
      message.error("Veuillez entrer un type de ligne et un couleur");
    }
  };

  const handleEditType = (type) => {
    setIsEditing(true);
    setEditingType(type); // Set the selected type for editing
    setNewType(type.name);

    setNewColor("#" + type.color);
    setIsModalVisible(true); // Open the modal for editing
  };

  const handleUpdateType = async () => {
    const hexString =
      typeof newColor === "string" ? newColor : newColor?.toHexString();
    if (newType.trim() && hexString.trim()) {
      try {
        await updateTypeLine(editingType.id, {
          name: newType,
          color: hexString.replace("#", ""),
        });

        setNewType("");
        setNewColor("");
        setIsModalVisible(false);
        setIsEditing(false);
        fetchTypes();
        message.success("Type d'infraction mis à jour");
      } catch (error) {
        message.error("Échec de la mise à jour du type de ligne.");
      }
    } else {
      message.error("Veuillez entrer un type de ligne et un couleur");
    }
  };

  const restForm = () => {
    setNewType("");
    setNewColor("");
    setIsEditing(false);
  };

  const columns = [
    {
      title: "Type de ligne",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "couleur",
      dataIndex: "color",
      key: "color",
      render: (text) => (
        <div className="flex items-center gap-2">
          <div className="w-6 h-6" style={{ backgroundColor: `#${text}` }} />
          {text}
        </div>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "right",
      render: (text, record) => (
        <Space size="middle">
          <PermissionRender requiredPermission={["type_line", "update"]}>
            <Button
              icon={<EditOutlined />}
              onClick={() => handleEditType(record)} // Open modal for editing
            >
              Modifier
            </Button>
          </PermissionRender>
        </Space>
      ),
    },
  ];

  return (
    <Layout className="min-h-screen">
      <Content className="py-6 sm:px-6 lg:px-8">
        <Card className="mb-6 shadow-sm">
          <Row gutter={16}>
            <Col xs={24} sm={24} md={24}>
              <PermissionRender requiredPermission={["type_line", "create"]}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setIsModalVisible(true)}
                  className="w-full"
                >
                  Créer un nouveau type de ligne
                </Button>
              </PermissionRender>
            </Col>
          </Row>
        </Card>

        <Card className="shadow-sm">
          <Table
            dataSource={types.map((item, index) => ({ key: index, ...item }))}
            columns={columns}
            pagination={false}
            loading={loading}
          />
        </Card>

        <Modal
          title={
            isEditing ? "Modifier le Type de ligne" : "Ajouter un Type de ligne"
          }
          visible={isModalVisible}
          onOk={isEditing ? handleUpdateType : handleAddType} // Handle update or add
          onCancel={() => {
            setIsModalVisible(false);
            restForm();
          }}
        >
          <div>
            <Input
              placeholder="Type de ligne"
              value={newType}
              onChange={(e) => setNewType(e.target.value)} // Update the new type value
            />

            <div className="mt-3 flex gap-4 items-center ">
              <span>Couleur : </span>
              <ColorPicker
                format="hex"
                value={newColor}
                onChange={setNewColor} // Update the color value
              />

              <div>
                {typeof newColor === "string"
                  ? newColor
                  : newColor?.toHexString()}
              </div>
            </div>
          </div>
        </Modal>
      </Content>
    </Layout>
  );
}

export default TypeLines;
